import { css } from 'styled-components'

import { type Themeable, transformThemeable } from '../themeable'

type Options = {
	/** Add a hover effect for buttons based on text-color. Default is on. */
	enableHoverEffect?: boolean
	/** Look of the ripple effect. Defaults to currentcolor, 0.3 opacity, 1.6 width. */
	ripple?: Themeable<{
		/** Color of the ripple effect */
		color: string
		/** Opacity of the ripple effect */
		opacity: number
		/** Size relative to width of container, or as a CSS length. */
		width: number | string
	}>
}

export const muiRipple = ({
	enableHoverEffect = true,
	ripple = {
		color: 'currentcolor',
		opacity: 0.3,
		width: 1.6,
	},
}: Options = {}) => css`
	&:not(:disabled) {
		/* :before element is used to create highlight-effects */
		&:before,
		/* :after element is used to create animated click-effect */
		&:after {
			content: '';
			display: block;
			position: absolute;
			opacity: 0;
			pointer-events: none;
			background-color: currentColor;
		}

		&:before {
			inset: 0;
			transition: opacity 0.2s;
		}

		${
			enableHoverEffect &&
			css`
				&:is(:focus-visible, :hover):before {
					opacity: 0.1;
				}
			`
		}

		&:after {
			background-color: ${transformThemeable(ripple, ({ color }) => color)};
			width: ${transformThemeable(ripple, ({ width }) => (typeof width === 'number' ? `${width * 100}%` : width))};
			/* Force height to match width, percentage padding is relative to parent width */
			padding-top: ${transformThemeable(ripple, ({ width }) => (typeof width === 'number' ? `${width * 100}%` : width))};
			top: 50%;
			left: 50%;
			border-radius: 50%;
			transform: translate(-50%, -50%);
			transition: transform 0.7s, opacity 0.9s;
		}

		&:active:after {
			transform: translate(-50%, -50%) scale(0, 0);
			opacity: ${transformThemeable(ripple, ({ opacity }) => opacity)};
			transition: none;
		}
	}
`
